import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles/index';
import { Button, Card, CardContent, Typography, MenuItem, Table, TableBody, TableRow, TableCell, TableHead, Icon, IconButton } from '@material-ui/core';

const styles = theme => ({
    root: {
        background: "url('/assets/images/backgrounds/dark-material-bg.jpg') no-repeat",
        backgroundSize: 'cover'
    },
    intro: {
        color: '#ffffff'
    },
    card: {
        width: '100%',
        maxWidth: 400
    }
});

class StudentCoursesTab extends Component {

    constructor(props) {
        super(props);
    }

    getCourseTable = (display, courses, student_id) => {
        if (!display) { return null }

        const currentCourseRows = courses.map(c => {
            return (
                <TableRow key={c.company_calendar_course_id}>
                    <TableCell>{c.CourseName}</TableCell>
                    <TableCell>
                        <IconButton
                            onClick={() => this.props.history.push(`/gradebook/student/event_list/${c.company_calendar_course_id}/${student_id}`)}
                        >
                            <Icon>book</Icon>
                        </IconButton>
                    </TableCell>
                </TableRow>
            )
        })

        const tableBase =
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Course</TableCell>
                        <TableCell>To Gradebook</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {currentCourseRows}
                </TableBody>
            </Table>

        return tableBase
    }

    render() {
        const { classes, student, progress } = this.props;
        // const {  } = this.state;
        // console.log(this.props);

        return (
            <div>
                <Typography variant="h5"> {progress.length > 0 ? 'Current Courses' : 'No Current Courses'} </Typography>
                {this.getCourseTable(progress.length > 0, progress, student.student_id)}
            </div>
        )
    }
}

// function mapDispatchToProps(dispatch) {
//     return bindActionCreators({

//     }, dispatch);
// }

// function mapStateToProps({ auth }) {
//     return {
//         auth
//     }
// }


// export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthStudentTab)));
export default withStyles(styles, { withTheme: true })(withRouter(connect(null, null)(StudentCoursesTab)));


// WEBPACK FOOTER //
// src/main/content/student/StudentCoursesTab.js